import PropTypes from 'prop-types'

export const MoneyType = PropTypes.shape({
    amount: PropTypes.number,
    currency: PropTypes.string,
})

export const BookingProductType = PropTypes.shape({
    product: PropTypes.shape({
        name: PropTypes.string,
        description: PropTypes.string,
        isDefault: PropTypes.bool,
        minStayMinutes: PropTypes.number,
        maxStayMinutes: PropTypes.number,
        advanceMinutes: PropTypes.number,
    }),
    availability: PropTypes.shape({
        availabilityStatus: PropTypes.string.isRequired,
        availabilityExtraInfo: PropTypes.object,
        priceQty: MoneyType,
    }),
})
